// extracted by mini-css-extract-plugin
module.exports = {"myProfileContainer":"MyProfile_myProfileContainer__3cqKv","myProfileButtonSpinner":"MyProfile_myProfileButtonSpinner__2GTS8"};